import React from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

interface CircularProgressBarProps {
    percentage: number;
    size?: number;
}

const CircularProgressBar: React.FC<CircularProgressBarProps> = ({ percentage, size = 200 }) => {
    return (
        <div style={{ width: size, height: size, margin: 'auto' }}>
            <CircularProgressbar
                value={percentage}
                text={`${percentage}%`}
                styles={buildStyles({
                    textSize: '18px',
                    pathColor: `rgba(62, 152, 62, ${percentage / 100})`,
                    textColor: '#000000',
                    trailColor: '#ffffff',
                })}
            />
        </div>
    );
};

export default CircularProgressBar;